import { StringUtils } from "utils";

const PHONE_TYPE_OPTIONS = {
    keys: {
        HOME: "home",
        CELL: "cell",
        WORK: "work",
        FAX: "fax",
        OTHER: "other"
    },
    getOptions: function() {
        return Object.keys(this.keys).map(type => ({
            key: this.keys[type],
            value: this.keys[type],
            text: StringUtils.capitalize(this.keys[type])
        }))
    }
}

export default PHONE_TYPE_OPTIONS;
